import { Fragment } from "react";
import { useHistory } from "react-router";
import Fade from "react-reveal/Fade";
import {
  FooterContainer,
  MainContent,
  FooterColumn,
  ColumnTitle,
  FooterLink,
  FooterInfo,
  LogosContainer,
  Image,
  Divider,
  BottomFooter,
  BottomContainer,
  Copyright,
  SocialSection,
  FollowUsText,
  IconContainer,
  SocialIcon,
} from "./styles/FooterStyles";
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

function Footer({ showNewsletter = false }) {
  const history = useHistory();
  const currentYear = new Date().getFullYear();
  const publicUrl = process.env.PUBLIC_URL || "";

  return (
    <Fragment>
      {showNewsletter && <mitur-newsletter title="Suscríbete al Boletín"></mitur-newsletter>}
      <FooterContainer>
        <MainContent>
        {/* Columna 1: Logos */}
        <FooterColumn>
          <LogosContainer>
            <Image src={`${publicUrl}/LogoMitur-letras-blancas.svg`} alt="Logo MITUR" />
            <Image src={`${publicUrl}/logo-gob-white-text.svg`} alt="Escudo República Dominicana" />
          </LogosContainer>
        </FooterColumn>

        {/* Divisor Vertical */}
        <Divider />

        {/* Columna 2: CONÓCENOS */}
        <FooterColumn>
          <ColumnTitle>Conócenos</ColumnTitle>
          <FooterInfo>
            Ministerio de Turismo de la República Dominicana
          </FooterInfo>
        </FooterColumn>

        {/* Columna 3: CONTÁCTANOS */}
        <FooterColumn>
          <ColumnTitle>Contáctanos</ColumnTitle>
          <FooterInfo>
            <strong>Tel:</strong> (809)-221-4660
          </FooterInfo>
          <FooterInfo>
            <strong>Fax:</strong> (809)-740-4500
          </FooterInfo>
          <FooterInfo>
            <strong>Email:</strong> info@mitur.gob.do
          </FooterInfo>
        </FooterColumn>

        {/* Columna 4: BÚSCANOS */}
        <FooterColumn>
          <ColumnTitle>Búscanos</ColumnTitle>
          <FooterInfo>
            Ave. Cayetano Germosén No. 419, esq. Ave. Gregorio Luperón, Santo Domingo, R.D.
          </FooterInfo>
        </FooterColumn>

        {/* Columna 5: INFÓRMATE */}
        <FooterColumn>
          <ColumnTitle>Infórmate</ColumnTitle>
          <FooterLink target="_blank" href="https://www.mitur.gob.do/terminos-de-uso/">
            Términos de Uso
          </FooterLink>
          <FooterLink onClick={() => history.push("/app/policy")}>
            Política de Privacidad
          </FooterLink>
          <FooterLink target="_blank" href="https://www.mitur.gob.do/preguntas-frecuentes/">
            Preguntas Frecuentes
          </FooterLink>
        </FooterColumn>
      </MainContent>

      <BottomFooter>
        <BottomContainer>
          <Copyright>
            &copy; {currentYear} Todos los Derechos Reservados. Desarrollado por la Dirección de Innovación.
          </Copyright>
          
          <SocialSection>
            <FollowUsText>SÍGUENOS</FollowUsText>
            <IconContainer>
              <SocialIcon href="https://www.facebook.com/MinisterioDeTurismoRD" target="_blank" rel="noopener noreferrer">
                <FacebookOutlinedIcon style={{ fontSize: '24px', color: '#1D2862' }} />
              </SocialIcon>
              <SocialIcon href="https://www.youtube.com/user/MinisterioTurismoRD" target="_blank" rel="noopener noreferrer">
                <YouTubeIcon style={{ fontSize: '24px', color: '#1D2862' }} />
              </SocialIcon>
              <SocialIcon href="https://twitter.com/TurismoRD" target="_blank" rel="noopener noreferrer">
                <TwitterIcon style={{ fontSize: '24px', color: '#1D2862' }} />
              </SocialIcon>
              <SocialIcon href="https://www.instagram.com/turismord/" target="_blank" rel="noopener noreferrer">
                <InstagramIcon style={{ fontSize: '24px', color: '#1D2862' }} />
              </SocialIcon>
            </IconContainer>
          </SocialSection>
        </BottomContainer>
      </BottomFooter>
    </FooterContainer>
  </Fragment>
  );
}

export default Footer;
